import { BuildingStatusEnum } from '@/enums/BuildingStatus';
import type { Building } from '@/typings/buildings/Building';

export function useBuilding() {
  function sortBuildingsByStatus(buildings: Building[]): Building[] {
    const sortedBuildings = [];
    sortedBuildings.push(...buildings.filter((b) => b.status === BuildingStatusEnum.Available && b.hasPromotion === true));
    sortedBuildings.push(...buildings.filter((b) => b.status === BuildingStatusEnum.Available && b.hasPromotion === false));
    sortedBuildings.push(...buildings.filter((b) => b.status === BuildingStatusEnum.Reserved));
    sortedBuildings.push(...buildings.filter((b) => b.status === BuildingStatusEnum.Full));
    return sortedBuildings;
  }

  return {
    sortBuildingsByStatus
  };
}